export default __webpack_public_path__ + "locales/ko-KR/OAuth.json?hash=1787cace31ea5351585e88d42c426f7e";